import { z } from "zod";

import { AssignStatus, SignalFilterStatus } from "@/enum/list.enum";

/**
 * The part of the list table's view every select-all bulk request carries besides its own filters:
 * the search, the tab's statuses, the reason sub-filters and the signal filter. A select-all sends
 * only the loaded page's ids and the API re-derives the rest from this, so a request that leaves one
 * out covers leads the table did not show (PREC-4441, PREC-4443, PREC-4450). Spread it into a bulk
 * request schema rather than declaring the fields again.
 */
export const selectAllScopeFields = {
	searchValue: z.string().optional(),
	assignStatuses: z.array(z.nativeEnum(AssignStatus)).optional(),
	exclusionReasons: z.array(z.string()).optional(),
	signalFilterStatus: z.array(z.nativeEnum(SignalFilterStatus)).optional(),
};
